export default __webpack_public_path__ + "static/media/Background_00142.319f91aa.png";